<template>
    <v-main>
        <!-- 限定先行プレミアムチケット -->
        <!-- <v-container class="pl-0 pr-0 opacity-70">
            <h3 class="text-center  py-5">限定先行プレミアムチケット</h3>
            <v-simple-table class="ma-5 text-center" light max-height="400px" max-width="100%">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-center" style="width:65%;">
                                チケット料金
                            </th>
                            <th class="text-center" style="width:35%;">
                                大人・小人
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="text-sm-caption text-md-subtitle-2 text-decoration-line-through">人気占い師・真木あかりの<br class="nobr-pc">
                                    西洋占星術による<br>
                                    詳細鑑定付き<br class="nobr-pc">
                                    プレミアムチケット</span></td>
                            <td><span class="sold" title="5,000">SOLD OUT</span></td>
                        </tr>
                        <tr>
                            <td><span class="text-sm-caption text-md-subtitle-2 text-decoration-line-through">オーラ鑑定
                                    <br class="nobr-pc">
                                    メッセージカード付き
                                    <br class="nobr-pc">
                                    プレミアムチケット</span></td>
                            <td><span class="sold" title="8,000">SOLD OUT</span></td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <p class="text-caption text-md-subtitle-2 text-center mt-2">販売期間：2021/6/30(水) 12:00〜7/16(金)23:59</p>
        </v-container> -->


        <!-- 通常入場チケット -->
        <v-container class="mt-10 pl-0 pr-0">
            <v-layout v-bind="binding" class="pt-5 pb-15">

                <!-- <v-flex xs12 sm6 class="pb-5 opacity-70">
                    <h3 class="text-center mb-5">先行前売通常入場チケット</h3>
                    <v-simple-table class="ma-5 text-center" light max-height="400px">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        チケット料金
                                    </th>
                                    <th class="text-center">
                                        大人
                                    </th>
                                    <th class="text-center">
                                        小人
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>平日</td>
                                    <td><span class="sold" title="1,800">SOLD OUT</span></td>
                                    <td><span class="sold" title="1,400">SOLD OUT</span></td>
                                </tr>
                                <tr>
                                    <td>休日</td>
                                    <td><span class="sold" title="2,000">SOLD OUT</span></td>
                                    <td><span class="sold" title="1,600">SOLD OUT</span></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <p class="text-caption text-md-subtitle-2 text-center mt-2">販売期間：2021/6/30(水)12:00〜7/16(金)23:59</p>
                </v-flex> -->

                <v-flex xs12>
                    <h3 class="text-center mb-5">一般販売通常入場チケット</h3>
                    <v-simple-table class="ma-5 text-center" light max-height="400px">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        チケット料金
                                    </th>
                                    <th class="text-center">
                                        大人
                                    </th>
                                    <th class="text-center">
                                        小人
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>平日</td>
                                    <td><span class="">2,000円</span></td>
                                    <td><span class="">1,600円</span></td>
                                </tr>
                                <tr>
                                    <td>休日</td>
                                    <td><span class="">2,200円</span></td>
                                    <td><span class="">1,800円</span></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <p class="text-caption text-md-subtitle-2 text-center mt-2">販売期間：2021/7/17(土)00:00〜8/27(金)18:30</p>
                </v-flex>
            </v-layout>
        </v-container>


        <!-- 花みくじ付き入場チケット -->
        <v-container class="mt-10 pl-0 pr-0">
            <v-layout class="pb-10">
                <v-img max-height="300" max-width="100%" v-for="({src},i) in img" :key="i" :src="src"></v-img>
            </v-layout>

            <v-layout v-bind="binding" class="pt-10 pb-15">

                <!-- <v-flex xs12 sm6 class="pb-5 opacity-70">
                    <h3 class="text-center mb-5">先行前売花みくじ付き通常入場チケット</h3>
                    <p class="text-center text-caption">Twitterで9万件いいねがついた話題の花みくじ付き</p>
                    <v-simple-table class="ma-5 text-center" light max-height="400px">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        チケット料金
                                    </th>
                                    <th class="text-center">
                                        大人
                                    </th>
                                    <th class="text-center">
                                        小人
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td>平日</td>
                                    <td><span class="sold" title="2,300">SOLD OUT</span></td>
                                    <td><span class="sold" title="1,900">SOLD OUT</span></td>
                                </tr>
                                <tr>
                                    <td>休日</td>
                                    <td><span class="sold" title="2,500">SOLD OUT</span></td>
                                    <td><span class="sold" title="2,100">SOLD OUT</span></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <p class="text-caption text-md-subtitle-2 text-center mt-2">販売期間：2021/6/30(水)12:00〜7/16(金)23:59</p>
                </v-flex> -->

                <v-flex xs12>
                    <h3 class="text-center mb-5">花みくじ付き通常入場チケット</h3>
                    <p class="text-center text-caption">Twitterで9万件いいねがついた話題の花みくじ付き</p>
                    <v-simple-table class="ma-5 text-center" light max-height="400px">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        チケット料金
                                    </th>
                                    <th class="text-center">
                                        大人
                                    </th>
                                    <th class="text-center">
                                        小人
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>平日</td>
                                    <td><span class="">2,500円</span></td>
                                    <td><span class="">2,100円</span></td>
                                </tr>
                                <tr>
                                    <td>休日</td>
                                    <td><span class="">2,700円</span></td>
                                    <td><span class="">2,300円</span></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <p class="text-caption text-md-subtitle-2 text-center mt-2">販売期間：2021/7/17(土)00:00〜8/27(金)18:30</p>
                </v-flex>
            </v-layout>
        </v-container>
    </v-main>
</template>

<script>
    export default {

        computed: {
            binding() {
                const binding = {}

                if (this.$vuetify.breakpoint.xsOnly) binding.column = true

                return binding
            },
        },

        data() {
            return {

                // src => バナー画像
                img: [{
                    src: './Images/hanamikuji.jpg',
                }],


            }
        },
    }
</script>

<style lang="scss" scoped>
    .nobr-pc {
        display: inline;

        @media screen and (min-width:735px) {
            display: none;
        }
    }

    .tickets-block {
        @media screen and (min-width:735px) {
            max-width: 800px;
        }
    }


    td {
        height: 90px !important;
    }

    .sold{
        color:#fd0a8c;
        } 
    
    .opacity-50{
        opacity: 0.5;
    }

    .opacity-70{
        opacity: 0.7;
    }
</style>>